/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  fill?: string;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24, fill = "none" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill={fill}>
    <path d="M7 17V11C7 9.67392 7.52678 8.40215 8.46447 7.46447C9.40215 6.52678 10.6739 6 12 6C13.3261 6 14.5979 6.52678 15.5355 7.46447C16.4732 8.40215 17 9.67392 17 11V17" stroke="#262626" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5 20C5 20.2652 5.10536 20.5196 5.29289 20.7071C5.48043 20.8946 5.73478 21 6 21H18C18.2652 21 18.5196 20.8946 18.7071 20.7071C18.8946 20.5196 19 20.2652 19 20V19C19 18.4696 18.7893 17.9609 18.4142 17.5858C18.0391 17.2107 17.5304 17 17 17H7C6.46957 17 5.96086 17.2107 5.58579 17.5858C5.21071 17.9609 5 18.4696 5 19V20Z" stroke="#262626" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M21 11H22" stroke="#262626" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18.5 3.5L18 4" stroke="#262626" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2 11H3" stroke="#262626" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 1V2" stroke="#262626" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4.92969 3.92969L5.63669 4.63669" stroke="#262626" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 11V17" stroke="#262626" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
